import React from 'react'
import injectSheet from 'react-jss'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import FromLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import MaskContent from '../../../common/mask-content/mask-content'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import classNames from 'classnames'
import Alert from 'pobble-components/dist/alert'
import {
  useFeatureCounter,
  SubsCrown
} from 'pobble-components/dist/subscriptions'

const TITLE_MAX_LENGTH = 50
const LESSON_OVERVIEW_MAX_LENGTH = 200

const styles = ({ COLORS, BREAKPOINTS }) => ({
  row: {
    marginTop: '20px',
    '&:first-child': {
      marginTop: '0'
    }
  },
  uploadWorkButton: {
    margin: '0 auto 0 -5px !important'
  },
  mobile: {
    display: 'none'
  },
  submitButton: {
    width: '100px',
    justifyContent: 'center'
  },
  alert: {
    marginBottom: '24px',
    '@media (min-width: 768px)': {
      display: 'none'
    }
  },
  [`@media (max-width: ${BREAKPOINTS.XS})`]: {
    desktop: { display: 'none' },
    mobile: { display: 'block' }
  }
})

const CreateLesson = ({
  classes,
  isOpen,
  onChange,
  onClose,
  onSubmit,
  pending,
  canUseLessons
}) => {
  const [createLessonCounter, createLessonSP] = useFeatureCounter(
    'PresentationCreation',
    sp => sp.lesson_planning.create_presentation
  )

  return (
    <Modal closeButton isOpen={isOpen} requestClose={onClose}>
      <ModalHeader>Create a new lesson</ModalHeader>
      <Formik
        onSubmit={values => {
          if (createLessonSP.restricted) {
            createLessonSP.showDialog({
              trigger: 'create-lesson',
              title:
                'You need a subscription to create and edit unlimited resources'
            })
          } else {
            onSubmit(values).then(createLessonCounter)
          }
        }}
        initialValues={{ title: '', lessonOverview: '' }}>
        {({
          handleSubmit,
          handleBlur,
          handleChange,
          values,
          errors,
          touched,
          isValid
        }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className={classNames(classes.form, {
                [classes.pending]: pending
              })}>
              <ModalContent legacy className={classes.holder}>
                <MaskContent apply={pending}>
                  <Alert className={classes.alert} type="warning">
                    Lessons cannot be edited on a mobile device.
                  </Alert>
                  <div>
                    <div className={classes.row}>
                      <FromLabel small spaceBetween htmlFor="startLessonTitle">
                        <span>Give your lesson a title</span>
                        <CharactersCount
                          value={values.title}
                          max={TITLE_MAX_LENGTH}
                        />
                      </FromLabel>
                      <FormInput
                        required={!createLessonSP.restricted}
                        placeholder="eg. Boudicca!"
                        name="title"
                        id="startLessonTitle"
                        value={values.title}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        maxLength={TITLE_MAX_LENGTH}
                        autoFocus={true}
                      />
                    </div>
                    <div className={classes.row}>
                      <FromLabel small spaceBetween htmlFor="startLessonLo">
                        <span className={classes.desktop}>
                          Provide an overview of this unit of work
                        </span>
                        <span className={classes.mobile}>
                          Learning overview
                        </span>
                        <CharactersCount
                          value={values.lessonOverview}
                          max={LESSON_OVERVIEW_MAX_LENGTH}
                        />
                      </FromLabel>
                      <FormTextArea
                        required={!createLessonSP.restricted}
                        placeholder="eg. Eg. We are discussing Boudicca’s speech and then we are writing our own."
                        id="startLessonLo"
                        name="lessonOverview"
                        value={values.lessonOverview}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        textAreaProps={{
                          maxLength: LESSON_OVERVIEW_MAX_LENGTH
                        }}
                      />
                    </div>
                  </div>
                </MaskContent>
              </ModalContent>
              <ModalFooter alignRight childrenGap>
                <Button action={onClose} tall simple>
                  Cancel
                </Button>
                <Button
                  icon={createLessonSP.restricted && <SubsCrown accent />}
                  className={classNames(classes.desktop, classes.submitButton)}
                  pending={pending}
                  tall
                  type="submit">
                  Create
                </Button>
              </ModalFooter>
            </form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default injectSheet(styles)(CreateLesson)
